var _title, _desc, _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgNavAccount = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "24px",
    viewBox: "0 0 21 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Account")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Account")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.25,0 L19.75,0 C20.9922136,0 22,1.00778644 22,2.25 L22,21.75 C22,22.9922136 20.9922136,24 19.75,24 L3.25,24 C2.00778644,24 1,22.9922136 1,21.75 L1,2.25 C1,1.00778644 2.00778644,0 3.25,0 Z M3.25,1.5 C2.83621356,1.5 2.5,1.83621356 2.5,2.25 L2.5,21.75 C2.5,22.1637864 2.83621356,22.5 3.25,22.5 L19.75,22.5 C20.1637864,22.5 20.5,22.1637864 20.5,21.75 L20.5,2.25 C20.5,1.83621356 20.1637864,1.5 19.75,1.5 L3.25,1.5 Z M11.5,4.223 C14.1842136,4.223 16.36,6.39878644 16.36,9.083 C16.36,11.7672136 14.1842136,13.943 11.5,13.943 C8.81578644,13.943 6.64,11.7672136 6.64,9.083 C6.64,6.39878644 8.81578644,4.223 11.5,4.223 Z M11.5,5.723 C9.64421356,5.723 8.14,7.22721356 8.14,9.083 C8.14,10.9387864 9.64421356,12.443 11.5,12.443 C13.3557864,12.443 14.86,10.9387864 14.86,9.083 C14.86,7.22721356 13.3557864,5.723 11.5,5.723 Z M18.9134762,18.6772868 C19.1066175,19.0437146 18.966141,19.497335 18.5997132,19.6904762 C18.2332854,19.8836175 17.779665,19.743141 17.5865238,19.3767132 C15.8147207,16.0152465 11.6543199,14.726501 8.29275143,16.4974561 C7.06456211,17.1449156 6.06091562,18.1485621 5.41345606,19.3767514 C5.22029367,19.7431681 4.76666523,19.8836184 4.40024857,19.6904561 C4.03383191,19.4972937 3.89338156,19.0436652 4.08654394,18.6772486 C4.87508438,17.1814379 6.09743789,15.9590844 7.59342611,15.1704504 C11.6879844,13.0133387 16.7554397,14.5830577 18.9134762,18.6772868 Z",
    id: "nav-account"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01.-Main-Nav-Icons",
    transform: "translate(-328.000000, -393.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav-Icons",
    transform: "translate(326.000000, 320.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic/Account",
    transform: "translate(1.000000, 73.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "streamline-icon-single-neutral-profile-picture@24x24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c/grey/600"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "nav-account-mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nav-account"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#nav-account"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#nav-account-mask-2)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNavAccount, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/nav-account.8fb76dbb.svg";
export { ForwardRef as ReactComponent };